import React from "react";
import { personNameMatchRange } from "@playbookai/types";

/**
 * A row's name with the part the query matched in bold and underlined, at
 * the word start the tenant search matched it (`personNameMatchRange`). The
 * underline is cyan: teal marks selection only (C7).
 */
export function PeopleFieldMatchedName({
  name,
  query,
}: {
  readonly name: string;
  readonly query: string;
}): React.ReactElement {
  const range = personNameMatchRange(name, query);
  if (!range) return <>{name}</>;
  return (
    <>
      {name.slice(0, range.start)}
      <mark className="bg-transparent font-bold text-inherit underline decoration-pb-cyan decoration-2 underline-offset-3">
        {name.slice(range.start, range.end)}
      </mark>
      {name.slice(range.end)}
    </>
  );
}
